// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_drawer__o6pVt","open":"drawer_open__QI1j-","drawer-container":"drawer_drawer-container__qUBNs"};